import React from 'react'
import PageList from '../../../components/PageListAPI'
import { getWeldingLogList, deleteWeldingLogById } from '../../../api/welding.api'
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';
export default function WeldingLogList(props) {
  const can = useCan()
  return <div className='App-paper'>
    <PageList
      name='welding-log-list'
      title='Журналы сварочных работ'
      columns={[
        { id: 'dateCreate', name: 'Дата создания', type: 'date', formatDate: 'LLL' },
        { id: 'name', name: 'Наименование', },
        { id: 'dateStart', name: 'Дата начала журнала', type: 'date', formatDate: 'DD.MM.YYYY' },
        { id: 'dateEnd', name: 'Дата окончания журнала', type: 'date', formatDate: 'DD.MM.YYYY' },
      ]}
      createItem={can(SLUGS.PROJECT.WELDING.MANAGE)}
      deleteItem={can(SLUGS.PROJECT.WELDING.MANAGE)}
      loadAPI={{
        request: getWeldingLogList,
        querty: {
        },
        param: {
          id: props.match.params.idProject
        },
      }}
      headerLink={<HeaderLink url={props.match.url} />}
      deleteAPI={deleteWeldingLogById(props.match.params.idProject)}
      {...props}
    />
  </div>
}

function HeaderLink({ url }) {
  const toLinkWelders = React.forwardRef((props1, ref) => (<Link ref={ref} to={url + '/welders'} {...props1} />));
  const toLinkWeldersE = React.forwardRef((props1, ref) => (<Link ref={ref} to={url + '/welders_e'} {...props1} />));
  return <React.Fragment>
    <Button key='welders' component={toLinkWeldersE} color="primary" >Тех. персонал</Button>
    <Button key='welders-e' component={toLinkWelders} color="primary" >Сварщики</Button>
  </React.Fragment>
}